import { MembersDetailPage } from '@/features/members/pages/members-detail-page';

const MembersDetailRoute = () => {
  return <MembersDetailPage />;
};

export default MembersDetailRoute;
